import { useEffect, useState } from "react";
import { IContextProvider } from "../../uxp";

export async function isAuthenticated(context: IContextProvider) {
    return new Promise<boolean>(async (done, nope) => {

        try {
            const response = await context.executeService('Lucy', 'IsAuthenticated', {}, { json: true })
            // cehck the response 
            done(response?.[0]?.authenticated == 'True')
        }
        catch (e) {
            // this will be due to use is not logged in 
            console.log('e');

            done(false)
        }
    })
}
type IAuthCheckerHook = (context: IContextProvider, interval?: number, callback?: (authenticated: boolean) => void) => boolean

export const useIsAuthenticated: IAuthCheckerHook = (context: IContextProvider, interval?: number) => {

    const [authenticated, setAuthenticated] = useState(true)

    useEffect(() => {
        isAuthenticated(context).then(res => setAuthenticated(res))

        if (interval) {
            setInterval(() => {
                isAuthenticated(context).then(res => setAuthenticated(res))
            }, interval)
        }

    }, [interval])

    return authenticated
}